import React from "react";

export default function TransportDashboard() {
  return (
    <div>
      <h2>TransportDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}